import * as Yup from 'yup'
import i18n from 'i18n'
import { emailLength, usernameOrEmail } from '@/constants/regex'

/**
 * ======================================
 * F O R M   V A L U E S
 * ======================================
 */

export type FormValuesLogin = {
  email: string
  password: string
  twoFactorCode: string
}

/**
 * ======================================
 * I N I T I A L   V A L U E S
 * ======================================
 */

export const initialValuesLogin: FormValuesLogin = {
  email: '',
  password: '',
  twoFactorCode: '',
}

/**
 * ======================================
 * V A L I D A T I O N S   S C H E M A S
 * ======================================
 */

const requiredString = Yup.string().required(i18n.t('error.requiredField'))

export const validationSchemaLogin = Yup.object().shape({
  email: requiredString.test(
    'emailOrUsername',
    i18n.t('invalidEmailOrUsername'),
    (value) => {
      const isEmail = value?.includes('@') || false
      return value
        ? isEmail
          ? usernameOrEmail.test(value) && emailLength.test(value)
          : usernameOrEmail.test(value)
        : false
    },
  ),
  password: requiredString,
})
